import React from 'react';

export default function Footer() {
  return (
    <footer>
      <p className='absolute h-6 w-full bottom-0 right-5 text-right'>
        &copy; Capstone Project Team MAGJAY.
      </p>
    </footer>
  );
}
